import React, { FC } from 'react';
import { HiFilter, HiOutlineCog } from 'react-icons/hi';
import { Button, Select, TextInput } from 'flowbite-react';
import { IDeviceListFilter } from '../../../types';

interface IDeviceFilterProps {
  deviceFilter: Partial<IDeviceListFilter>;
  setDeviceFilter: (filter: Partial<IDeviceListFilter>) => void;
  handleFilter: () => void;
  onUpdateQueueSchedule: () => void;
  queueSchedule: boolean;
  queueScheduleLoading: boolean;
}

const deviceStatus = [
  { label: 'Connected', value: 'CONNECTED' },
  { label: 'Unpaired', value: 'UNPAIRED' },
  { label: 'Error', value: 'ERROR' },
  { label: 'Opening', value: 'OPENING' },
  { label: 'Restart', value: 'RESTART' },
];

export const DeviceFilter: FC<IDeviceFilterProps> = ({
  deviceFilter,
  setDeviceFilter,
  handleFilter,
  onUpdateQueueSchedule,
  queueSchedule,
  queueScheduleLoading,
}) => {
  return (
    <div className="items-center flex justify-between">
      <div className="flex gap-4">
        <TextInput
          placeholder="Ad, Ip ya da Numara"
          value={deviceFilter.q || ''}
          onChange={(e: any) => {
            setDeviceFilter({
              ...deviceFilter,
              q: e.target.value,
            });
          }}
        />
        <Select
          value={deviceFilter.clientStatus || ''}
          onChange={(e: any) => {
            setDeviceFilter({
              ...deviceFilter,
              clientStatus: e.target.value,
            });
          }}
        >
          <option value="">Status</option>
          {deviceStatus.map((status) => (
            <option key={status.value} value={status.value}>
              {status.label}
            </option>
          ))}
        </Select>
        <Select
          value={deviceFilter.isMessageSent || ''}
          onChange={(e: any) => {
            setDeviceFilter({
              ...deviceFilter,
              isMessageSent: e.target.value,
            });
          }}
        >
          <option value="">Mesaj Gönderim</option>
          <option value="1">Aktif</option>
          <option value="0">Pasif</option>
        </Select>
        <Select
          value={deviceFilter.deviceType || ''}
          onChange={(e: any) => {
            setDeviceFilter({
              ...deviceFilter,
              deviceType: e.target.value,
            });
          }}
        >
          <option value="">Tüm Cihazlar</option>
          <option value="INVITE">Davet</option>
          <option value="BOT">Bot</option>
          <option value="AGENT_WP">WP Temsilci</option>
          <option value="AGENT_TG">TG Temsilci</option>
        </Select>
        <Button color="light" onClick={handleFilter}>
          <HiFilter />
        </Button>
      </div>

      {/* queue schedule option */}
      {/* <div className="items-center flex gap-2">
        <Button
          color="blue"
          onClick={onUpdateQueueSchedule}
          isProcessing={queueScheduleLoading}
          disabled={queueScheduleLoading}
          size="md"
        >
          <HiOutlineCog className="mr-2" />
          Kuyruk: {queueSchedule ? 'Açık' : 'Kapalı'}
        </Button>
      </div> */}
    </div>
  );
};
